import React, { useMemo } from "react";
import { Typography } from "@mui/material";
import ResponsiveDrawer from "views/components/ResponsiveDrawer";
import { MaterialReactTable } from "material-react-table";
import OTCKampoData from "data/otc-kampo.json";

function OTCKampo() {
  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "処方番号",
      },
      {
        accessorKey: "name",
        header: "名前",
      },
      {
        accessorKey: "set",
        header: "生薬",
      },
    ],
    []
  );

  return (
    <ResponsiveDrawer>
      <div style={{ maxWidth: "calc(100vw - 48px)" }}>
        <MaterialReactTable
          columns={columns}
          data={OTCKampoData}
          enableColumnFilterModes
          enableColumnOrdering
          enableGrouping
          enablePinning
          enableRowSelection={false}
          initialState={{ density: "compact" }}
          renderTopToolbarCustomActions={() => (
            <Typography paragraph style={{ margin: 0 }}>一般用漢方製剤製造販売承認基準</Typography>
          )}
        />
      </div>
    </ResponsiveDrawer>
  );
}

export default OTCKampo;
